export const AGENT_TYPE_HTTPS = 'https'
export const AGENT_TYPE_HTTP = 'http'
